import {BASE_TITLES, FILTER_KEYS, STATUS_CODES, STATUS_TITLES} from '../../../shared/constants';
import {TypeServiceRequestStatusCode} from '../../../shared/types/serviceRequest.types';
import {PrevSelectedData} from '../store/prevSelectedStore';

export const filterServiceRequestsBy: string[][] = [
  [BASE_TITLES.apartment.base, FILTER_KEYS.apartment],
  [BASE_TITLES.street.base, FILTER_KEYS.street],
  [BASE_TITLES.city.base, FILTER_KEYS.city],
  [BASE_TITLES.region.base, FILTER_KEYS.region],
  [BASE_TITLES.contractNumber.base, FILTER_KEYS.contractNumber],
  [BASE_TITLES.house.base, FILTER_KEYS.house],
  [BASE_TITLES.deviceType.base, FILTER_KEYS.serviceType],
  [BASE_TITLES.requestStatus.base, FILTER_KEYS.status],
  [BASE_TITLES.taskLocation.base, FILTER_KEYS.taskLocationCode],
  [BASE_TITLES.workers.base, FILTER_KEYS.workerUid],
];

export const statusCodes: [string, TypeServiceRequestStatusCode][] = [
  [STATUS_TITLES.CREATED, STATUS_CODES.CREATED],
  [STATUS_TITLES.DELAYED, STATUS_CODES.DELAYED],
  [STATUS_TITLES.NOTIFYING, STATUS_CODES.NOTIFYING],
  [STATUS_TITLES.READY_TO_PROCESS, STATUS_CODES.READY_TO_PROCESS],
  [STATUS_TITLES.IN_PROGRESS, STATUS_CODES.IN_PROGRESS],
  [STATUS_TITLES.EXECUTED, STATUS_CODES.EXECUTED],
  [STATUS_TITLES.CANCELLED, STATUS_CODES.CANCELLED],
  [STATUS_TITLES.REJECTED, STATUS_CODES.REJECTED],
  [STATUS_TITLES.DONE, STATUS_CODES.DONE],
  [STATUS_TITLES.APPROVED, STATUS_CODES.APPROVED],
];

export const statusCodesAssign: [string, TypeServiceRequestStatusCode][] = [
  [STATUS_TITLES.CREATED, STATUS_CODES.CREATED],
  [STATUS_TITLES.NOTIFYING, STATUS_CODES.NOTIFYING],
  [STATUS_TITLES.DELAYED, STATUS_CODES.DELAYED],
  [STATUS_TITLES.READY_TO_PROCESS, STATUS_CODES.READY_TO_PROCESS],
  [STATUS_TITLES.IN_PROGRESS, STATUS_CODES.IN_PROGRESS],
];

export const filterLabelMap = new Map<string, string>(
  filterServiceRequestsBy.map((i) => [...i].reverse()) as Iterable<readonly [string, string]>,
);

export const prevSelectedKeys: (keyof PrevSelectedData)[] = ['apartment', 'house', 'counter'];
